import { labelStyles } from '@zapier/style-encapsulation';

export const Styles = labelStyles('ZapierLogoSymbol', {
  root: { display: 'block' },
});
